import {Link, useParams} from "react-router-dom";
import GoBack from "./components/GoBack";
import Accordion from "./components/Accordion";
import {useContext, useEffect, useState} from "react";
import Data from "./Data";
import Empty from "./components/Empty";
import Meta from "../components/Meta";
import AppContext from "../../context";
import {formatDuration} from "./utils/duration";
import { trackMetaEvent } from '../../utils/metaPixel';

const Experience = ({ basePath = '' }) => {
    const context = useContext(AppContext);

    const { id } = useParams();
    if(!id) window.location.href = "/"

    const [experience, setExperience] = useState([]);
    const [loading, setLoading] = useState(true);
    const [bundles, setBundles] = useState([]);

    useEffect(async () => {
        try {
            const experience = await Data.fetchExperienceById( { id})
            setExperience(experience.data)
            const bundles = await Data.fetchBundlesForExperience({ experienceId: experience.data._id })
            setBundles(bundles.data)
            const pixelId = context.domain?.metaPixelEnabled ? context.domain?.metaPixelId : null;
            if (pixelId && experience.data?.name) {
                trackMetaEvent({
                    pixelId,
                    eventName: 'ViewContent',
                    params: {
                        content_type: 'experience',
                        content_ids: [id],
                        content_name: experience.data.name,
                        value: Number(experience.data.price || 0),
                        currency: context.domain?.metaCurrency || 'GBP'
                    }
                });
            }
        } catch (error) {
            window.location.href = "/"
        } finally {
            setLoading(false)
        }
    }, []);

    return (
        <>
            <Meta title={experience.name} />
            <div>
                <GoBack to={basePath || "/"} label={"View all classes"} />

                <div className={"flex flex-col xl:flex-row xl:container xl:mx-auto xl:px-8"}>

                    {loading ?
                        <div className={"w-full m-8"}>
                            <Empty>
                                <p>Loading...</p>
                            </Empty>
                        </div>
                        :
                        <>
                            <div
                                className={"bg-backgroundGrey w-full aspect-video sm:h-80 sm:aspect-auto flex items-center relative lg:container lg:mx-auto lg:m-8 lg:mb-8 lg:rounded-lg object-cover xl:aspect-video overflow-hidden"}>
                                {experience.isPublished === false ? <p className={"absolute top-2 left-2 bg-red-500 text-white px-2 py-1 rounded text-sm"}>Unpublished</p> : null}
                                {experience.image ?
                                    <img src={experience.image} alt={experience.name} className={"w-full h-full object-cover"}/>
                                    : null}
                            </div>

                            <div className={"p-8 container mx-auto"}>
                                <h1 className={"text-2xl text-primary"}>{experience.name}</h1>
                                <div className={"[&_*]:text-textGrey flex gap-2 mt-1"}>
                                    <p>{formatDuration(experience.duration)}</p>
                                    <p>•</p>
                                    <p>&pound;{experience.price} {experience.pricingLabel || 'per person'}</p>
                                </div>

                                <p className={"mt-4 text-textGrey"}>{experience.shortDescription}</p>

                                {experience.description ? <Accordion heading={"Description"} defaultOpen={true}>
                                    <p className={"text-textGrey"}>{experience.description}</p>
                                </Accordion> : null}

                                {experience.location ? <Accordion heading={"Location"} defaultOpen={true}>
                                    <p className={"text-textGrey"}>{experience.location}</p>
                                </Accordion> : null}

                                {experience.additionalDetails ? <Accordion heading={"Additional Details"}>
                                    <p className={"text-textGrey"}>{experience.additionalDetails}</p>
                                </Accordion> : null}

                                {experience.cancellationPolicy ? <Accordion heading={"Cancellation Policy"}>
                                    <p className={"text-textGrey"}>{experience.cancellationPolicy}</p>
                                </Accordion> : null}

                                <Link to={'checkout'} className={"inline-block bg-primary py-2 px-4 w-full text-white text-center rounded-md mt-6 border-0"}>Book Now</Link>

                                {bundles?.length ? (
                                    <div className={"mt-6"}>
                                        <h3 className={"text-lg"}>Bundles</h3>
                                        <div className={"mt-2 border rounded-md divide-y"}>
                                            {bundles.map(b => {
                                                const first = [...b.events].sort((a,b) => new Date(a.date) - new Date(b.date))[0];
                                                return (
                                                    <div key={b._id} className={"p-3 flex flex-row justify-between items-center gap-1"}>
                                                        <div className={"flex flex-col gap-1"}>
                                                            <p className={"font-semibold"}>{b.name}</p>
                                                            <p className={"text-textGrey text-sm"}>{b.events.length} events • Starts {new Date(first.date).toLocaleDateString()} • £{b.price} {experience.pricingLabel || 'per person'}</p>
                                                        </div>
                                                        <div>
                                                            <Link to={`checkout/book-bundle?bundle=${b._id}`} className={"inline-block bg-primary py-2 px-4 w-full text-white text-center rounded-md border-0"}>
                                                                View Bundle
                                                            </Link>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        </>
                    }
                </div>
            </div>
        </>
    )
}

export default Experience
